export var config = {
    ENV: '',
    ADB_APP_FILE: '',
    MAPBOX_API_KEY: '',
    SANITY_PROJECT_ID: '',
    SANITY_DATASET: '',
    CONTENTFUL_SPACE: '',
    CONTENTFUL_ENVIRONMENT: '',
    CONTENTFUL_PUBLIC_TOKEN: '',
    CONTENTFUL_PREVIEW_TOKEN: '',
    AWS_CORE_SERVICE_ID: '',
    AWS_ELASTIC_SERVICE_ID: '',
    AWS_STATIONS_SERVICE_ID: '',
    SHOPIFY_ID: '',
    SHOPIFY_PRIMARY_COLLECTION: '',
    SHOPIFY_ADMIN_ACCESS_TOKEN: '',
    SHOPIFY_STOREFRONT_ACCESS_TOKEN: ''
};
export const setConfig = (newConfig) => {
    config = newConfig;
};
export const getConfig = () => {
    return config;
};
//# sourceMappingURL=globals.js.map